import commonRes from '../abstract.resource';
import {readServiceCategory} from '../serializers/servicecategory.serializer';

const mod = angular.module('app.common.resources.service-category', [commonRes])

.factory('ServiceCategoryResource', function ($q, AbstractResource) {
  class ServiceCategoryResource extends AbstractResource {
    constructor() {
      super('service-categories', ServiceCategoryResource.fromBackend, true);
    }

    /**
     * Parse a service category retrieved from the backend.
     * @param {Object} o
     * @returns {ServiceCategory}
     */
    static fromBackend(o) {
      return readServiceCategory(o).makeImmutable();
    }
  }

  return new ServiceCategoryResource();
});

export default mod.name;
